import { render } from "./resources_cms.vue?vue&type=template&id=418c05be&scoped=true"
import script from "./resources_cms.vue?vue&type=script&lang=js"
export * from "./resources_cms.vue?vue&type=script&lang=js"

import "./resources_cms.vue?vue&type=style&index=0&id=418c05be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418c05be"]])

export default __exports__